__turbopack_context__.v({
  "input__inlinebutton": "oYn1lW_input__inlinebutton",
  "newsletter": "oYn1lW_newsletter",
  "newsletter__input": "oYn1lW_newsletter__input",
  "newsletter_label": "oYn1lW_newsletter_label",
});
